import * as _ from 'lodash';
import * as moment from 'moment';
import 'moment/locale/fr';
import { v4 as uuidv4 } from 'uuid';
import { BehaviorSubject, Subject } from 'rxjs';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { InvoiceCancelComponent } from '@app/features/invoices/actions/cancel/invoice-cancel.component';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalHelper } from '@app/shared/models/modal-helper.model';
import { takeUntil } from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GroupTypeModel } from '@app/core/models/groups/group-type.model';
import { InvoiceViewType } from '@app/core/models/invoices/invoice-view-type.model';
import { InvoiceModel } from '@app/core/models/invoices/invoice.model';
import { InvoiceService } from '@app/core/services/invoice.service';
import { AuthenticationInfoService } from '@app/core/guards/authentication-info.service';
import { MultiSelectModel } from '@app/shared/models/multi-select.model';
import {
  TableRowAction,
  TableActionIcon,
  TableMassAction,
  TableIndication,
} from '@app/shared/models/table-action-type.model';
import { TableColumnsConfigKey } from '@app/core/models/configuration/table-columns-config-key.model';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { ReferentialItem } from '@app/core/models/shared/referential-item.model';
import { FileDownloadService } from '@app/core/services/filedownload.service';
import { EmailTemplateType } from '@app/core/models/emails/email-template-type.model';
import { ProgressComponent } from '@app/shared/components/progress/progress.component';
import { HttpCancelService } from '@app/core/services/http-cancel.service';
import { InvoiceSearchCriteriaModel } from '@app/core/models/invoices/invoice-search-criteria.model';
import { AssetService } from '@app/core/services/asset.service';
import { RecipientEntitiesService } from '@app/core/services/recipient-entities.service';
import { InvoiceFilterService } from '../invoice-filter-service';
import { InvoiceFilterConfig } from '@app/core/models/invoices/invoice-filter-config.model';
import { InvoiceFilters } from '@app/core/models/invoices/invoice-filters.model';
import { GroupService } from '@app/core/services/group.service';
import { InvoiceDateProcessingType } from '@app/core/models/invoices/invoice-date-processing-type.model';
import { InvoiceSelectRef1Component } from '../../actions/invoice-select-ref1/invoice-select-ref1.component';
moment.locale('fr');

@Component({
  selector: 'app-invoice-list-voucher-validated',
  templateUrl: './invoice-list-voucher-validated.component.html',
  styleUrls: ['./invoice-list-voucher-validated.component.scss'],
})
export class InvoiceListVoucherValidatedComponent
  extends InvoiceFilterService
  implements OnInit, OnDestroy
{
  unsubscribe$: Subject<boolean> = new Subject<boolean>();
  invoices: InvoiceModel[];
  data: InvoiceModel[] = [];
  tableRowActions: TableRowAction[] = [];
  tableMassActions: TableMassAction[] = [];
  tableIndications: TableIndication[] = [];
  dropdownListGroups: ReferentialItem[] = [];
  selectedItemsGroups: ReferentialItem[] = [];
  dropdownSettings: IDropdownSettings = {};
  dropdownSettingsGroups: IDropdownSettings = {};
  configKey: string = TableColumnsConfigKey.INVOICEVOUCHERVALIDATED;
  exportFileName: string;

  private massDownloadRequestSubject$ = new BehaviorSubject<string>(null);
  public massDownloadRequest$ = this.massDownloadRequestSubject$.asObservable();
  progressDialog: MatDialogRef<ProgressComponent>;
  panelOpenState: boolean = true;
  recipientEntitiesDropdownList: ReferentialItem[] = [];
  selectedRecipientEntitiesItems: ReferentialItem[] = [];
  multipleSelectionWithSearchDropdownSettings: IDropdownSettings = {};
  singleSelectionWithoutSearchDropdownSettings: IDropdownSettings = {};
  assetsDropdownList: ReferentialItem[] = [];
  selectedAssetsItems: ReferentialItem[] = [];
  processingDateTypesDropdownList: ReferentialItem[] = [];
  processingDateTypesSelectedItems: ReferentialItem[] = [];

  title: string;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private groupService: GroupService,
    private invoiceService: InvoiceService,
    private fileDownloadService: FileDownloadService,
    public dialog: MatDialog,
    private multiSelectModel: MultiSelectModel,
    private httpCancelService: HttpCancelService,
    public assetService: AssetService,
    public recipientEntityService: RecipientEntitiesService,
    public sessionStorageService: SessionStorageService,
    private authenticationInfoService: AuthenticationInfoService
  ) {
    super(route, sessionStorageService, assetService, recipientEntityService);
    this.title = 'FACTURES A COMPTABILISER';
    this.exportFileName = 'Factures_A_Comptabiliser';
    this.invoiceSearchCriteriaModel = new InvoiceSearchCriteriaModel();
    this.invoiceFiltersConfig = new InvoiceFilterConfig(
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      false,
      false,
      false,
      false,
      false,
      true
    );
  }

  ngOnInit(): void {
    this.dropdownSettings = this.multiSelectModel.getSettings();
    this.dropdownSettingsGroups = this.multiSelectModel.getSettings(
      'Id',
      'Label',
      false,
      true,
      false,
      true
    );
    this.multipleSelectionWithSearchDropdownSettings =
      this.multiSelectModel.getMultipleSelection(true);
    this.multipleSelectionWithSearchDropdownSettings.allowRemoteDataSearch =
      true;

    this.processingDateTypesDropdownList = [
      {
        Id: InvoiceDateProcessingType.PROCESSEDAT,
        Label: 'Date de traitement opérationnel',
      },
      {
        Id: InvoiceDateProcessingType.WORKFLOWCOMPLETEDAT,
        Label: 'Date de validation',
      },
    ];
    this.processingDateTypesSelectedItems =
      this.processingDateTypesDropdownList.filter(
        (c) => c.Id === InvoiceDateProcessingType.PROCESSEDAT
      );
    this.singleSelectionWithoutSearchDropdownSettings =
      this.multiSelectModel.getSingleSelection(true);

    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.ZOOM,
        'Voir le détail de la facture',
        this.onZoom
      )
    );
    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.PDF,
        'Ouvrir la facture',
        this.onOpenPdf
      )
    );
    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.CANCELPROCESS,
        'Annuler et renvoyer la facture',
        this.onSendBackVoucher,
        this.ensureVoucherBelongsToUserGroups
      )
    );
    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.PROCESS,
        'Traiter la facture',
        this.onVoucherValidation,
        this.ensureVoucherBelongsToUserGroups
      )
    );
    this.tableRowActions.push(
      new TableRowAction(
        TableActionIcon.VOUCHER,
        'Télécharger le bon à payer',
        this.onVoucherDownload
      )
    );

    this.tableMassActions.push(
      new TableMassAction(
        TableActionIcon.PROCESS,
        'Traiter les factures',
        this.onVouchersValidation,
        this.ensureVouchersBelongToUserGroups
      )
    );
    this.tableMassActions.push(
      new TableMassAction(
        TableActionIcon.VOUCHER,
        'Télécharger les bons à payer',
        this.onMassVouchersDownload
      )
    );
    this.tableIndications.push(
      new TableIndication(
        TableActionIcon.ERROR,
        "L'association Référence 1 et société n'est pas conforme",
        (invoice: InvoiceModel) => invoice.SupplierHasWarning
      )
    );
    this.data = this.innerFilterInvoices(
      this.invoices,
      this.getFilters(),
      false
    );

    this.groupService
      .getGroupsByType([GroupTypeModel.NONERPCOMPTABILITY])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((groups) => {
        this.dropdownListGroups = groups.map(
          (g) => new ReferentialItem(g.Id, g.Name)
        );
        let groupsFilter = null;
        this.restoreFilters((data: InvoiceFilters) => {
          this.selectedAssetsItems = data?.Assets ?? [];
          this.selectedRecipientEntitiesItems = data?.RecipientEntities ?? [];
          this.processingDateTypesSelectedItems =
            data?.ProcessingDateType != null
              ? [data.ProcessingDateType]
              : this.processingDateTypesDropdownList.filter(
                  (c) => c.Id === InvoiceDateProcessingType.PROCESSEDAT
                );
          groupsFilter = data?.Groups;
        });
        this.restoreGroupFilters(groupsFilter);
      });

    this.massDownloadRequest$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((requestId: string) => {
        if (_.isNil(requestId)) {
          if (!_.isNil(this.progressDialog)) {
            this.progressDialog.close(false);
          }
          return;
        }

        const progressModal = new ModalHelper().getProgressConfig(requestId);
        this.progressDialog = this.dialog.open(
          ProgressComponent,
          progressModal
        );

        this.progressDialog
          .afterClosed()
          .pipe(takeUntil(this.unsubscribe$))
          .subscribe((isSuccess: boolean) => {
            this.massDownloadRequestSubject$.next(null);
            this.progressDialog = null;
            if (!isSuccess) {
              this.httpCancelService.cancelPendingRequests();
            }
          });
      });
  }

  restoreGroupFilters = (groups: ReferentialItem[]) => {
    if (_.isNil(groups)) {
      this.selectedItemsGroups = this.dropdownListGroups.filter((r) =>
        this.authenticationInfoService.authentificatedUser.GroupsMembership.NonERPComptabilityGroups.includes(
          r.Id
        )
      );
    } else {
      this.selectedItemsGroups = groups;
    }

    this.onGroupsChange();
  };

  protected onAssetFetched(assets: ReferentialItem[]) {
    this.assetsDropdownList = assets;
  }

  protected onRecipientEntitiesFetched(recipientEntities: ReferentialItem[]) {
    this.recipientEntitiesDropdownList = recipientEntities;
  }

  onGroupsChange() {
    const groupsId = this.selectedItemsGroups.map((g) => g.Id);
    this.invoiceService
      .getApprovedVouchers(groupsId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (approvedVouchers) => {
          this.data = this.innerFilterInvoices(
            approvedVouchers,
            this.getFilters(),
            true
          );
          this.invoices = approvedVouchers;
        },
        () => {
          this.data = [];
        }
      );
  }

  onClearFilters = (): void => {
    this.selectedItemsGroups = [];
    this.selectedAssetsItems = [];
    this.selectedRecipientEntitiesItems = [];
    this.invoiceSearchCriteriaModel = new InvoiceSearchCriteriaModel();
    this.onGroupsChange();
    this.onFiltersCleared.next();
    this.storeFilters(this.getFilters());
  };

  dateChangeSearch(result: any) {
    this.dateChange(result.type, result.selectedDate);
    this.filterInvoices();
  }

  filterInvoices(): void {
    this.data = this.innerFilterInvoices(
      this.invoices,
      this.getFilters(),
      true
    );
  }

  onSelectProcessingDateTypesItem(item: ReferentialItem): void {
    this.processingDateTypesSelectedItems = [item];
    this.filterInvoices();
  }

  onSelectAll(items: any, filter: string) {
    switch (filter) {
      case 'recipientEntity':
        this.selectedRecipientEntitiesItems = items;
        this.filterInvoices();
        break;
      case 'assets':
        this.selectedAssetsItems = items;
        this.filterInvoices();
        break;
      case 'groups':
        this.selectedItemsGroups = items;
        this.onGroupsChange();
        break;
    }
  }

  onVoucherValidation = (data: InvoiceModel) => {
    const modalConfig = new ModalHelper().getConfirmationConfig(
      'Êtes-vous sûr de vouloir enregistrer ce traitement comptable'
    );
    const dialog = this.dialog.open(ModalComponent, modalConfig);

    return dialog
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isConfirmed: boolean) => {
        if (isConfirmed) this.openConfirmVoucherValidation(data.Id);
      });
  };

  onVouchersValidation = (data: string[]) => {
    const modalConfig = new ModalHelper().getConfirmationConfig(
      'Êtes-vous sûr de vouloir enregistrer ces traitements comptables'
    );
    const dialog = this.dialog.open(ModalComponent, modalConfig);

    return dialog
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isConfirmed: boolean) => {
        if (isConfirmed) this.openConfirmVouchersValidation(data);
      });
  };

  onMassVouchersDownload = (selectedIds: string[]) => {
    if (selectedIds.length > 0) {
      let massDownloadRequest = uuidv4();
      this.massDownloadRequestSubject$.next(massDownloadRequest);
      this.invoiceService
        .getAttachmentVouchers(selectedIds, massDownloadRequest)
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(
          (blobData: Blob) => {
            this.massDownloadRequestSubject$.next(null);
            let localDate = new Date().toLocaleDateString();
            this.fileDownloadService.downloadBlob(
              blobData,
              `${this.configKey}_${localDate}.zip`,
              'application/zip'
            );
          },
          (_) => {
            this.massDownloadRequestSubject$.next(null);
            const modalErreurConfig = new ModalHelper().getAlertConfig(
              `Une erreur est survenue lors du téléchargement.`
            );
            this.dialog.open(ModalComponent, modalErreurConfig);
          }
        );
    }
  };

  openConfirmVoucherValidation = (invoiceId: string) => {
    this.invoiceService
      .validateVoucher(invoiceId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((_) => {
        this.data = this.data.filter((i) => i.Id != invoiceId);
      });
  };

  openConfirmVouchersValidation = (invoicesId: string[]) => {
    this.invoiceService
      .validateVouchers(invoicesId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((_) => {
        this.data = this.data.filter((i) => !invoicesId.includes(i.Id));
      });
  };

  sendBackVoucher(featureType: EmailTemplateType, invoiceModel): void {
    const modalConfig = new ModalHelper().getCancelModalConfig(
      {
        InvoiceNumber: invoiceModel.Number,
        InvoiceId: invoiceModel.Id,
        FeatureType: featureType,
      },
      true
    );

    this.dialog.open(InvoiceCancelComponent, modalConfig);
  }

  onSendBackVoucher = (data: InvoiceModel) => {
    const confimModal = new ModalHelper().getConfirmationConfig(
      'Êtes-vous sûr de vouloir annuler et renvoyer cette facture ?'
    );
    const dialog = this.dialog.open(ModalComponent, confimModal);

    return dialog
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((result) => {
        if (result) {
          this.sendBackVoucher(EmailTemplateType.CancelInvoice, data);
        }
      });
  };

  onZoom = (data: InvoiceModel) => {
    this.router.navigate([
      'invoices',
      InvoiceViewType.VOUCHERVALIDATED,
      'detail',
      data.Id,
    ]);
  };

  onOpenPdf = (data: InvoiceModel) => {
    window.open(
      `invoices/${InvoiceViewType.VOUCHERVALIDATED}/detail-pdf/${data.Id}`,
      '_blank'
    );
  };

  onVoucherDownload = (invoice: InvoiceModel) => {
    this.invoiceService
      .getAttachmentVoucher(invoice.Id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(
        (blobData: Blob) => {
          let date = moment(invoice.IssuedAt).format('YYYYMMDo');
          this.fileDownloadService.downloadBlob(
            blobData,
            `${invoice.SupplierCompanyName}_${invoice.Number}_${date}.pdf`,
            'application/pdf'
          );
        },
        (_) => {
          const modalErreurConfig = new ModalHelper().getAlertConfig(
            `Une erreur est survenue lors du téléchargement.`
          );
          this.dialog.open(ModalComponent, modalErreurConfig);
        }
      );
  };

  ensureVoucherBelongsToUserGroups = (data: InvoiceModel) => {
    if (
      !this.authenticationInfoService.authentificatedUser.GroupsMembership
        ?.NonERPComptabilityGroups?.length
    ) {
      return false;
    }

    return this.authenticationInfoService.authentificatedUser.GroupsMembership.NonERPComptabilityGroups.includes(
      data.Workflow.NonErpGroupId
    );
  };

  ensureVouchersBelongToUserGroups = (data: string[]) => {
    if (
      !this.authenticationInfoService.authentificatedUser.GroupsMembership
        ?.NonERPComptabilityGroups?.length
    ) {
      return false;
    }
    const selectedInvoices = this.data.filter((invoice: InvoiceModel) =>
      data.includes(invoice.Id)
    );
    return !selectedInvoices.some(
      (invoice: InvoiceModel) =>
        !this.authenticationInfoService.authentificatedUser.GroupsMembership.NonERPComptabilityGroups.includes(
          invoice.Workflow.NonErpGroupId
        )
    );
  };

  private getFilters(): InvoiceFilters {
    return {
      Assets: this.selectedAssetsItems,
      RecipientEntities: this.selectedRecipientEntitiesItems,
      Groups: this.selectedItemsGroups,
      ProcessingDateType: _.head(this.processingDateTypesSelectedItems),
    } as InvoiceFilters;
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
  }

  exportAsExcel(): void {
    this.onExportExcelCaller.next();
  }

  onShowFilter(panelvalue: boolean) {
    this.panelOpenState = panelvalue;
  }

  onCreateManual = () => {
    const refSelectModal = new ModalHelper().getSelectRef1ModalConfig();
    const dialog = this.dialog.open(InvoiceSelectRef1Component, refSelectModal);

    dialog
      .afterClosed()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((value: ReferentialItem) => {
        if (!_.isNil(value) && !_.isNil(value.Label)) {
          this.router.navigate(['invoices/manual'], {
            queryParams: { PrimaryReferenceCreateId: value.Id },
          });
        }
      });
  };
}
